<template>
  <div>
    <template v-if="list.length > 1">
      <Swiper
        v-if="list.length > 1"
        :modules="[SwiperAutoplay, SwiperPagination]"
        :slides-per-view="1"
        :loop="true"
        :autoplay="{ delay: 5000, disableOnInteraction: false }"
        :pagination="paginationProps"
        class="relative"
      >
        <SwiperSlide v-for="item in list" :key="item.title">
          <BaseNewsCard :card="item" />
        </SwiperSlide>
      </Swiper>
      <div class="swiper-pagination-custom"></div>
    </template>
    <BaseNewsCard v-else :card="list[0]" />
  </div>
</template>
<script setup lang="ts">
import type { PaginationOptions } from 'swiper/types'
import type { NewsItem } from '@/components/module/home-screen-2'
defineProps({
  list: {
    type: Array as PropType<NewsItem[]>,
    default: () => []
  }
})
const paginationProps = ref<PaginationOptions>({
  type: 'bullets',
  el: '.swiper-pagination-custom',
  bulletClass: 'swiper-pagination-bullet-custom',
  bulletActiveClass: 'swiper-pagination-bullet-active-custom',
  renderBullet: (index: number, className: string) => {
    return `<span class="${className}"></span>`
  }
})
</script>
<style lang="scss">
.swiper-pagination-bullet-custom {
  @apply w-6 h-0.5 bg-dark mx-0.5 transition-colors duration-200;
}
.swiper-pagination-bullet-active-custom {
  @apply bg-primary-color;
}
</style>
<style lang="scss" scoped>
.swiper-pagination-custom {
  @apply w-full mt-1 h-1 flex justify-center items-center;
}
</style>
